import React from 'react';
import { MdOutlineLightMode, MdOutlineDarkMode, MdInfoOutline } from "react-icons/md";
import { TbLocation, TbEye, TbEyeOff } from "react-icons/tb";

const Header = ({ toggleDarkMode, darkMode, toggleInfo, onLocateUser, toggleEasyMode, easyMode }) => {
  const handleLogoClick = () => {
    window.location.href = '/';
  };

  return (
    <header className="flex justify-between items-center pl-px py-4 bg-white dark:bg-zinc-900 text-zinc-800 dark:text-zinc-200">  
      <div className="h-8 w-auto cursor-pointer" onClick={handleLogoClick}>        
        <img 
          src="/oo_light.svg" 
          alt="OceanOrb Logo" 
          className="h-full w-auto pointer-events-none dark:hidden"
          draggable="false"
          onContextMenu={(e) => e.preventDefault()}
        />
        <img 
          src="/oo_dark.svg" 
          alt="OceanOrb Logo" 
          className="h-full w-auto pointer-events-none hidden dark:block"
          draggable="false"
          onContextMenu={(e) => e.preventDefault()}
        />
      </div>

      <div className="flex items-center space-x-1 min-[375px]:space-x-1.5 sm:space-x-2">
        <button
          onClick={onLocateUser}
          className="h-9 p-2 text-xl rounded-full bg-zinc-200 dark:bg-zinc-800 text-zinc-800 dark:text-zinc-200 hover:bg-zinc-300 dark:hover:bg-zinc-700 focus:outline-none"
          aria-label="Locate User"
          title="My Location"
        >
          <TbLocation />
        </button>
        
        <button
          onClick={toggleEasyMode}
          className="h-9 p-2 text-xl rounded-full bg-zinc-200 dark:bg-zinc-800 text-zinc-800 dark:text-zinc-200 hover:bg-zinc-300 dark:hover:bg-zinc-700 focus:outline-none"
          aria-label={easyMode ? "Hide Easy Info" : "Switch to Easy Mode"}
          title={easyMode ? "Hide Easy Info" : "Switch to Easy Mode"}
        >
          {easyMode ? <TbEyeOff size={21} /> : <TbEye size={21} />}
        </button>
        
        <button
          onClick={toggleInfo}
          className="h-9 p-2 text-xl rounded-full bg-zinc-200 dark:bg-zinc-800 text-zinc-800 dark:text-zinc-200 hover:bg-zinc-300 dark:hover:bg-zinc-700 focus:outline-none"
          aria-label="Information"
          title="Information"
        >
          <MdInfoOutline size={21} />
        </button>
        <button
          onClick={toggleDarkMode}
          className="h-9 p-2 text-xl rounded-full bg-zinc-200 dark:bg-zinc-800 text-zinc-800 dark:text-zinc-200 hover:bg-zinc-300 dark:hover:bg-zinc-700 focus:outline-none"
          aria-label="Toggle Dark Mode"
          title="Toggle Dark Mode"
        >
          <span className="dark:hidden">
            <MdOutlineDarkMode size={21} />
          </span>
          <span className="hidden dark:block">
            <MdOutlineLightMode size={21} />
          </span>
        </button>
      </div>
    </header>
  );
};

export default Header;